import { useState, type ReactNode } from 'react';
import { AppHeader } from './AppHeader';
import { AppSidebar } from './AppSidebar';

export function AppLayout({ children }: { children: ReactNode }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="d-flex flex-column min-vh-100">
            <AppHeader toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

            <div className="d-flex flex-grow-1 position-relative">
                <AppSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

                <main className="flex-grow-1 p-3 ms-md-auto" style={{ marginLeft: sidebarOpen ? 0 : 0 }}>

                    <div className="container-fluid" style={{ marginLeft: 'var(--sidebar-width, 0px)' }}>
                        {/* 
                  Let's fix the layout strategy properly.
                  Mobile: Sidebar absolute/fixed over content. Content W-100.
                  Desktop: Sidebar fixed left. Content margin-left 250px.
               */}
                        <style>{`
                 @media (min-width: 768px) {
                   .main-content-wrapper { margin-left: 250px; }
                 }
               `}</style>

                        <div className="main-content-wrapper w-100">
                            {children}
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}
